const en = {
  nav: {
    home: "Home",
    about: "About",
    markets: "Markets",
    services: "Services",
    partners: "Partners",
    manufacturers: "For Manufacturers",
    news: "News",
    contact: "Contact",
    partner_cta: "Become a Partner",
  },
  hero: {
    eyebrow: "European Electric Mobility Alliance",
    title_line1: "The European Distribution Platform",
    title_line2: "for Electric Mobility",
    subtitle: "Connecting manufacturers with Europe's most experienced distribution network. We don't simply import vehicles. We build brands.",
    cta_primary: "Become a Partner",
    cta_secondary: "Explore the Alliance",
    scroll: "Scroll to discover",
  },
  why: {
    eyebrow: "Why EEMA",
    title: "Why Manufacturers Choose EEMA",
    subtitle: "A single commercial infrastructure covering every stage of European market entry.",
    cards: {
      distribution: { title: "European Distribution Network", desc: "Access established importers and distributors across multiple European countries under one commercial agreement." },
      marketing: { title: "Marketing & Brand Launch", desc: "Digital marketing, PR, trade shows, lead generation and social media coordinated at European scale." },
      dealer: { title: "Dealer Development", desc: "Structured recruitment, onboarding, contracts, standards and performance management of the dealer network." },
      sales: { title: "Sales Management", desc: "Fleet, retail, B2B, government, corporate accounts and financing programs executed by local commercial teams." },
      after: { title: "After Sales", desc: "Service network, warranty management, parts logistics, technical support and customer care across Europe." },
      training: { title: "Training Academy", desc: "Technical certification, sales training, dealer education and product-specialist programs — online and in market." },
      regulatory: { title: "Regulatory Support", desc: "Homologation, compliance, documentation and local-market adaptation coordinated with certified partners." },
    },
  },
  markets: {
    eyebrow: "European Footprint",
    title_line1: "One Alliance.",
    title_line2: "Multiple Markets.",
    subtitle: "EEMA operates through a founding network of national distributors across strategic European markets, with a defined roadmap for expansion.",
    legend_active: "Founding Markets",
    legend_future: "Expansion Roadmap",
    status_operational: "Operational",
    status_expansion: "Under Evaluation",
    tooltip_partner: "Local Partner",
    tooltip_dealers: "Dealer Network",
    tooltip_status: "Status",
    largest: "Largest market",
    countries: {
      italy: { name: "IFS Region", partner: "Founding Partner", dealers: "80+ dealers", note: "Italy, France & Spain" },
      germany: { name: "Germany", partner: "Founding Partner", dealers: "60+ dealers", note: "DACH hub" },
      switzerland: { name: "Switzerland", partner: "Founding Partner", dealers: "20+ dealers", note: "Premium segment" },
      netherlands: { name: "Benelux", partner: "Founding Partner", dealers: "43 dealers", note: "Netherlands, Belgium & Luxembourg" },
      baltics: { name: "Baltic Regions & Sweden", partner: "Founding Partner", dealers: "38 dealers", note: "Sweden, Estonia, Latvia & Lithuania" },
      france: { name: "France", partner: "Part of IFS", dealers: "Part of IFS Region", note: "IFS Region" },
      spain: { name: "Spain", partner: "Part of IFS", dealers: "Part of IFS Region", note: "IFS Region" },
      belgium: { name: "Belgium", partner: "Founding Partner", dealers: "Part of Benelux", note: "Benelux hub" },
      luxembourg: { name: "Luxembourg", partner: "Founding Partner", dealers: "Part of Benelux", note: "Benelux hub" },
      uk: { name: "United Kingdom", partner: "In discussion", dealers: "-", note: "Q2 2026" },
      portugal: { name: "Portugal", partner: "In discussion", dealers: "-", note: "Q3 2026" },
      greece: { name: "Greece", partner: "Roadmap", dealers: "-", note: "2026" },
      austria: { name: "Austria", partner: "Roadmap", dealers: "-", note: "2026" },
      poland: { name: "Poland", partner: "Roadmap", dealers: "-", note: "2026" },
      nordics: { name: "Nordics", partner: "Roadmap", dealers: "-", note: "2027" },
      czech: { name: "Czech Republic", partner: "Roadmap", dealers: "-", note: "2026" },
      hungary: { name: "Hungary", partner: "Roadmap", dealers: "-", note: "2026" },
      romania: { name: "Romania", partner: "Roadmap", dealers: "-", note: "2027" },
      croatia: { name: "Croatia", partner: "Roadmap", dealers: "-", note: "2027" },
    },
  },
  build: {
    eyebrow: "What We Build",
    title: "A complete go-to-market platform",
    subtitle: "From the manufacturer to the final customer — EEMA operates every commercial link.",
    steps: ["Manufacturer", "EEMA", "Marketing", "Dealer Network", "Sales", "Service", "Customer"],
  },
  gotomarket: {
    eyebrow: "Complete Go-To-Market",
    title: "Eleven steps, one integrated commercial platform",
    steps: [
      "Manufacturer", "Market Analysis", "Homologation", "Pricing Strategy", "Brand Launch",
      "Dealer Recruitment", "Training", "Marketing", "Sales", "Aftersales", "Growth",
    ],
  },
  capabilities: {
    eyebrow: "Alliance Capabilities",
    title: "Measurable industrial capability",
    subtitle: "The scale, experience and infrastructure required to launch and grow electric mobility brands in Europe.",
    items: [
      { value: 6, suffix: "", label: "Countries Covered" },
      { value: 15, suffix: "", label: "Target Countries" },
      { value: 250, suffix: "+", label: "Dealer Network" },
      { value: 50, suffix: "+", label: "Years of Industry Experience" },
    ],
    footnote: "Brands managed: multiple. After-sales centres: growing.",
  },
  compare: {
    eyebrow: "Why an Alliance?",
    title: "The strategic difference",
    without_title: "Without EEMA",
    with_title: "With EEMA",
    without: ["Create local company", "Recruit team", "Find dealers", "Create marketing", "Build service network", "Manage logistics", "Years of investment"],
    with: ["Existing distributors", "Existing dealer network", "Marketing platform ready", "Commercial team in place", "Technical support operational", "After-sales infrastructure", "Immediate market access"],
  },
  members: {
    eyebrow: "Governance",
    title: "Founding Members",
    subtitle: "A council of European executives with decades of experience in distribution, dealer development and industrial mobility.",
    future_title: "Future Alliance Members",
    future_subtitle: "EEMA is currently evaluating strategic partners for expansion markets. Open positions are reserved for established national distributors.",
    open_position: "Open Position",
    apply: "Apply as Member",
    profiles: [
      { name: "Francesco M. Farina", role: "Founding Partner", country: "IFS Region", years: "25+ years", competencies: "Distribution, dealer development, L-category EV" },
      { name: "Andreas Ewig", role: "Founding Partner", country: "Germany", years: "20+ years", competencies: "Retail networks, fleet sales, DACH markets" },
      { name: "Toine Oosterbosch", role: "Founding Partner", country: "Benelux", years: "18+ years", competencies: "Benelux distribution, aftersales" },
      { name: "Thomas Heggli", role: "Founding Partner", country: "Switzerland", years: "22+ years", competencies: "Premium segment, homologation" },
      { name: "Raimondas Vysniauskas", role: "Founding Partner", country: "Baltic Regions & Sweden", years: "15+ years", competencies: "Northern Europe expansion" },
    ],
    open_positions: ["United Kingdom", "Portugal", "Poland", "Nordics"],
  },
  services_grid: {
    eyebrow: "Services",
    title: "Eighteen integrated capabilities",
    items: ["Market Entry", "Distribution", "Marketing", "Dealer Development", "CRM", "Sales", "Fleet", "Training", "Warranty", "Parts", "Technical Support", "Business Intelligence", "Logistics", "Compliance", "Digital Advertising", "Lead Generation", "Customer Experience", "Network Expansion"],
  },
  brands: {
    eyebrow: "Partner Manufacturers",
    title: "Manufacturers we want to partner with",
    subtitle: "EEMA is actively evaluating collaborations with European and international electric mobility brands.",
    categories: ["Chinese EV manufacturers", "European startups", "L-category manufacturers", "Microcars", "Electric scooters", "Light commercial EV", "Medical mobility", "Neighborhood EV"],
  },
  method: {
    eyebrow: "The EEMA Method",
    title: "Seven structured steps from validation to European scale",
    steps: [
      { name: "Market Validation", desc: "Quantitative and qualitative analysis of country-level demand." },
      { name: "Business Planning", desc: "Commercial model, pricing, volumes and financials." },
      { name: "Launch Strategy", desc: "Brand positioning, homologation and go-to-market plan." },
      { name: "Dealer Development", desc: "Recruitment, contracts, standards and onboarding." },
      { name: "Commercial Operations", desc: "Sales, marketing and CRM execution." },
      { name: "After Sales", desc: "Service, warranty, parts and technical support." },
      { name: "European Expansion", desc: "Progressive rollout to additional EEMA markets." },
    ],
  },
  news: {
    eyebrow: "Newsroom",
    title: "Industry insights and alliance updates",
    view_all: "View all news",
    read_more: "Read more",
    back: "Back to news",
    category_all: "All",
  },
  cta_final: {
    eyebrow: "Strategic Partnership",
    title: "Ready to Expand Across Europe?",
    subtitle: "Partner with EEMA and leverage an established commercial platform covering Europe's most strategic electric mobility markets.",
    button: "Request a Meeting",
  },
  footer: {
    tagline: "The European integrated distribution platform for electric mobility brands.",
    company: "Company",
    resources: "Resources",
    legal: "Legal",
    privacy: "Privacy",
    terms: "Terms",
    imprint: "Imprint",
    rights: "All rights reserved.",
    contact_us: "Contact us",
  },
  contact: {
    eyebrow: "Contact",
    title: "Speak with the Alliance",
    subtitle: "For manufacturers, investors, distributors and strategic partners. All inquiries are handled directly by the EEMA executive office.",
    form: {
      name: "Full name",
      email: "Business email",
      company: "Company",
      subject: "Subject",
      message: "Your message",
      submit: "Send message",
      success: "Message received. The EEMA office will contact you shortly.",
      error: "Unable to submit. Please try again.",
    },
    office: "European Office",
    email_label: "Business email",
    linkedin_label: "LinkedIn",
  },
  partner_form: {
    eyebrow: "Partner Application",
    title: "Become a Strategic Partner",
    subtitle: "Reserved for OEMs, national distributors and strategic mobility investors.",
    company: "Company name",
    contact: "Contact person",
    role: "Role",
    email: "Business email",
    country: "Country",
    website: "Website",
    type: "Partnership type",
    type_options: ["Manufacturer / OEM", "National Distributor", "Strategic Investor", "Service Partner"],
    message: "Message",
    submit: "Submit application",
    success: "Application received. The EEMA executive office will respond within 5 business days.",
  },
  about: {
    hero_title: "The alliance behind European electric mobility",
    hero_subtitle: "EEMA is a private European alliance of established national distributors dedicated to launching and scaling electric mobility brands across the continent.",
    mission_title: "Mission",
    mission_text: "To provide manufacturers with the fastest, most reliable commercial infrastructure to enter and scale in Europe.",
    vision_title: "Vision",
    vision_text: "To become the reference commercial platform for electric mobility in every strategic European market by 2030.",
    values_title: "Core Values",
    values: [
      { name: "Execution", desc: "We measure success in delivered vehicles, active dealers and operational service centres." },
      { name: "Industrial Rigor", desc: "Corporate governance, compliance and process discipline in every market." },
      { name: "Long-term Vision", desc: "EEMA is built for decades of European mobility transformation." },
      { name: "European Identity", desc: "Local execution, European coordination, international reach." },
    ],
    history_title: "Alliance History",
    history_text: "Founded by five established European distributors, EEMA formalises decades of individual expertise into a single integrated commercial platform. The alliance was created in response to the accelerating entry of international electric mobility brands into Europe and the growing complexity of national homologation, dealer and after-sales requirements.",
    governance_title: "Governance",
    governance_text: "EEMA is governed by an Executive Council composed of the managing directors of each founding member. Strategic decisions require council consensus. Day-to-day operations are coordinated by the EEMA central office.",
  },
  markets_page: {
    hero_title: "Covered Markets",
    hero_subtitle: "Six founding markets. Fifteen target markets. One integrated European commercial platform.",
    insights_title: "Market insights",
    coverage_title: "Dealer coverage",
  },
  services_page: {
    hero_title: "Services",
    hero_subtitle: "Every capability required to launch, grow and scale an electric mobility brand in Europe — delivered under one commercial framework.",
    sections: {
      marketing: { title: "Marketing", desc: "Brand positioning, digital advertising, PR, events, trade shows, lead generation and social media coordinated at European scale." },
      dealer: { title: "Dealer Management", desc: "Dealer recruitment, contracting, standards, performance and expansion across the EEMA footprint." },
      sales: { title: "Sales", desc: "Retail, fleet, B2B, government and corporate accounts, financing, remarketing and dealer sales support." },
      aftersales: { title: "After Sales", desc: "Certified service network, warranty management, parts logistics, technical support and customer care." },
      training: { title: "Training", desc: "Certified technical, sales and product-specialist programs delivered online and in market." },
      compliance: { title: "Compliance", desc: "Homologation, regulatory documentation, local adaptation, VAT, WLTP and CE certification." },
      crm: { title: "CRM", desc: "Central CRM platform aligning dealer, distributor and manufacturer data across Europe." },
      logistics: { title: "Logistics", desc: "Import, port operations, PDI centres, national storage and dealer distribution." },
      bd: { title: "Business Development", desc: "Market intelligence, opportunity mapping, tenders and strategic account development." },
    },
  },
  partners_page: {
    hero_title: "Partners",
    hero_subtitle: "The European distributors, strategic investors and service partners that constitute the EEMA commercial platform.",
    founding: "Founding Companies",
    future: "Future Members",
    collabs: "Strategic Collaborations",
    become: "Become a Member",
  },
  manufacturers_page: {
    hero_title: "For Manufacturers",
    hero_subtitle: "EEMA is the fastest, most structured way to enter Europe. One contract, one platform, five operational markets from day one.",
    benefits_title: "Benefits",
    benefits: [
      "Immediate access to six founding markets",
      "One commercial contract, five distributors",
      "Existing dealer network of 250+ points of sale",
      "Certified after-sales and parts logistics",
      "European homologation and compliance coordination",
      "Central marketing and CRM platform",
    ],
    process_title: "Process",
    process: [
      "Initial commercial evaluation",
      "Non-disclosure agreement",
      "Market analysis per country",
      "Business plan and commercial offer",
      "Alliance agreement",
      "Launch execution",
    ],
    case_title: "Case Studies",
    case_placeholder: "Confidential case studies available under NDA on request.",
    model_title: "Commercial Model",
    model_text: "EEMA operates as an integrated commercial platform, not as a broker. Each manufacturer signs a single European framework agreement with EEMA, while national distributors execute locally under aligned standards. Financial models include importer margin, marketing investment and structured performance targets.",
  },
  admin: {
    title: "EEMA Admin",
    login: "Sign in",
    email: "Email",
    password: "Password",
    articles: "Articles",
    inquiries: "Partner Inquiries",
    messages: "Contact Messages",
    logout: "Logout",
    new_article: "New Article",
    edit: "Edit",
    delete: "Delete",
    published: "Published",
    draft: "Draft",
    save: "Save",
    cancel: "Cancel",
  },
};
export default en;
